module.exports = function() {
  return new Worker(__webpack_public_path__ + "1e85d1b76c3bbe728b49.worker.js");
};